import { ObjectId } from "@/types/object-id";
import { userRole } from "@/types/user";
import { profileApi } from "@/store/profile/endpoints";
import { ApiEndpointBuilder } from "@/services/api/types";
import { usersApi } from ".";
import { PlanType } from "@/store/tenants/endpoints/tenants";

const updateUser = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: ({ id, firstName, lastName, email, phoneNumber, userRoles, licenses }) => ({
      url: `/users/${id}`,
      method: "PUT",
      body: {
        id,
        firstName,
        lastName,
        email,
        phoneNumber,
        userRoles,
        licenses,
      },
    }),
    async onQueryStarted(args, { dispatch, queryFulfilled }) {
      const patchFetchResult = dispatch(
        usersApi.util.updateQueryData("searchUsers", {}, draftList => {
          return {
            ...draftList,
            data: [
              ...(draftList?.data ?? []).map(x =>
                x.id === args?.id
                  ? {
                      ...x,
                      ...args,
                      roles: args.userRoles
                        ?.filter(role => role.enabled)
                        .map(role => role.roleName),
                      licenses: [...new Set([...x.licenses, ...args.licenses])],
                    }
                  : x
              ),
            ],
          };
        })
      );

      try {
        await queryFulfilled;

        const currentEmployeeResult = await dispatch(
          profileApi.endpoints.getCurrentProfile.initiate()
        );
        const currentEmployeeId = currentEmployeeResult.data?.id;

        if (args.id === currentEmployeeId) {
          dispatch(profileApi.util.invalidateTags(["currentEmployee"]));
        }
      } catch (error) {
        console.error(error);
        patchFetchResult.undo();
      }
    },
    invalidatesTags: ["tenantDetails"],
  });
};

type Request = {
  id?: ObjectId;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  userRoles?: userRole[];
  licenses: PlanType[];
};

export default updateUser;
